const clientWidth = document.body.clientWidth

export const isMobile = clientWidth <= 768